import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Navbar.css';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [scrollDirection, setScrollDirection] = React.useState('up');
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const [companyDropdownOpen, setCompanyDropdownOpen] = React.useState(false);
  const [lastScrollY, setLastScrollY] = React.useState(0);
  const navigate = useNavigate();

  //Navigate to Koffieland page
  const handleKoffielandClick = () => {
    navigate('/koffieland');
  };

  const handleTechnologyClick = () => {
    navigate('/technology');
  };

  const handleSolutionsClick = () => {
    navigate('/solutions');
  };

  React.useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > lastScrollY) {
        setScrollDirection('down');
      } else {
        setScrollDirection('up');
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  // Toggle the Company dropdown in mobile view
  const handleCompanyToggle = (e) => {
    // For mobile view, prevent default to avoid navigation
    if (window.innerWidth <= 992) {
      e.preventDefault();
      setCompanyDropdownOpen((prev) => !prev);
    }
  };

  // Close mobile menu when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (e) => {
      if (mobileMenuOpen && !e.target.closest('.navbar-menu') && !e.target.closest('.mobile-menu-toggle')) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [mobileMenuOpen]);

  // Close company dropdown when mobile menu is closed
  React.useEffect(() => {
    if (!mobileMenuOpen) {
      setCompanyDropdownOpen(false);
    }
  }, [mobileMenuOpen]);

  // Prevent body scrolling when mobile menu is open
  React.useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  return (
    <motion.nav 
      className={`navbar ${scrollDirection === 'down' ? 'scrolled-down' : 'scrolled-up'}`}
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container navbar-container">
        <motion.a 
          href="/" 
          className="navbar-logo"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <img src="https://storage.googleapis.com/app_darkendimg/assets/kland.png" alt="Koffieland Logo" />
        </motion.a>

        <div className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <div className="mobile-menu-header">
            <motion.a 
              href="/" 
              className="navbar-logo mobile-logo"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <img src="https://storage.googleapis.com/app_darkendimg/assets/kland.png" alt="Koffieland Logo" />
            </motion.a>
            <div 
              className="mobile-menu-close"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span></span>
              <span></span>
            </div>
          </div>
          
          <ul className="navbar-links">
            <li>
              <motion.a 
               
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleKoffielandClick}
              >
                Koffieland
              </motion.a>
            </li>
            <li>
              <motion.a 
                
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleSolutionsClick}
              >
                Solutions
              </motion.a>
            </li>
            <li>
              <motion.a 
                
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleTechnologyClick}
              >
                Technology
              </motion.a>
            </li>
            <li className={`dropdown ${companyDropdownOpen ? 'active' : ''}`}>
              <motion.button 
                className="dropdown-toggle"
                onClick={handleCompanyToggle}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Company <span className="dropdown-icon">▼</span>
              </motion.button>
              <ul className="dropdown-menu">
                <li><a href="/about" onClick={() => setMobileMenuOpen(false)}>About</a></li>
                <li><a href="/team" onClick={() => setMobileMenuOpen(false)}>Team</a></li>
                <li><a href="/careers" onClick={() => setMobileMenuOpen(false)}>Careers</a></li>
              </ul>
            </li>
          </ul>
          
          
        </div>

        <motion.a
  href="#get-delivery"
  className="btn-get-delivery-btn-desktop-cta"
  initial={{
    backgroundColor: "#077336",
    borderRadius: "20px",
    color: "#fff",
    padding: "10px 20px",
    fontSize: "16px",
    textDecoration: "none",
    display: "inline-block"
  }}
  whileHover={{
    scale: 1.05,
    backgroundColor: "#121212"
  }}
  whileTap={{ scale: 0.95 }}
>
  <span className="dot">•</span> Visit Koffieland
</motion.a>






        <div 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
